import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class RecoveryPasswordService {
  private apiUrl = `${environment.apiUrl}/password/recover/request`;
  constructor(private http: HttpClient) { }

  recoverPassword(email: string): Observable<{ status: string, message: string }> {
    return this.http.post<{ status: string, message: string }>(this.apiUrl, { email });
  }
}